import {IOffice} from "./types";

export enum OfficeTypes {
    GET_OFFICES = "@@offices/GET_OFFICES",
    GET_OFFICES_SUCCESS = "@@offices/GET_OFFICES_SUCCESS",

    ADD_OFFICE = "@@offices/ADD_OFFICE",
    ADD_OFFICE_SUCCESS = "@@offices/ADD_OFFICE_SUCCESS",

    FAIL_OFFICES = "@@offices/FAIL_OFFICES",

    CLEAR_OFFICES = "@@offices/CLEAR_OFFICES",

    MODAL_OFFICE = "@@offices/MODAL_OFFICE",
}

export interface OfficeState {
    data: Array<IOffice>;

    pagination: Object;
    error: Object;
    loading: boolean,
    loaded: boolean,

    isOpenModal: boolean,
}

